<article class="block-partner section-outset-y" (fstrInViewport)="initSwiper()" [once]="true">
  <div class="container position-relative z-2">
    <!--<h2 class="text-max-width-xs" *ngIf="block.title" [innerHTML]="block.title | highlight : '' : false : 'squiggle-round'"></h2>-->

    <h2 class="text-max-width h1" *ngIf="block.title">
      <ngx-dynamic-hooks
        [options]="{ sanitize: false, updateOnPushOnly: true }"
        [content]="block.title | highlight : 'font-display fw-bold' : false : true : 'circle-01'"
        data-split
        [duration]="400"
        [context]="{ delayAnimation: 800, startShapeAnimation: inviewPort }"
        class="splitting splitting--word-in"
      ></ngx-dynamic-hooks>
    </h2>
  </div>

  <svg class="d-none">
    <filter
      id="monochrome"
      x="-10%"
      y="-10%"
      width="120%"
      height="120%"
      filterUnits="objectBoundingBox"
      primitiveUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feColorMatrix
        type="matrix"
        values="1 0 0 0 0
      1 0 0 0 0
      1 0 0 0 0
      0 0 0 1 0"
        in="SourceGraphic"
        result="colormatrix"
      />
      <feComponentTransfer in="colormatrix" result="componentTransfer">
        <feFuncR type="table" tableValues="0.11" />
        <feFuncG type="table" tableValues="0.13" />
        <feFuncB type="table" tableValues="0.16" />
        <feFuncA type="table" tableValues="0 1" />
      </feComponentTransfer>
      <feBlend mode="hue" in="componentTransfer" in2="SourceGraphic" result="blend" />
    </filter>
  </svg>

  @defer {
  <swiper-container #swiper init="false">
    <swiper-slide *ngFor="let partner of loopingPartnersSlides; trackBy: trackByFn">
      <div>
        <a
          class="partner"
          [href]="partner.url"
          target="_blank"
          [style.--logo-image-url]="'url(' + partner.image.url + '?trim.threshold=80&width=900&height=900&mode=pad)'"
        >
          <!-- &trim.percentpadding=0.5 -->
          <div class="partner__image"></div>
          <div class="partner__image__test"></div>
          <span class="sr-only">{{ partner.title }}</span>
        </a>
      </div>
    </swiper-slide>
  </swiper-container>
  }
</article>
